exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-control[data-v-f391f0a6], .multiselect.multiselect-city.form-control[data-v-f391f0a6] {\n    padding: 0 !important;\n}\n", ""]);

// exports
